import { useStaticQuery, graphql } from 'gatsby'
import dedupe from 'dedupe'

export const useBlogCategories = () => {
  const { allBlogCategory } = useStaticQuery(categoriesQuery)
  return allBlogCategory.nodes
    ? dedupe(allBlogCategory.nodes, node => node.slug)
    : null
}

const categoriesQuery = graphql`
  query allArticleCategoryQuery {
    allBlogCategory {
      nodes {
        ...BlogCategory
      }
    }
  }
`
